export const DEFAULT_QUERY_CONFIG = {
	STALE_TIME: 1000 * 60 * 5, // 5 minutes
	PAGE_SIZE: 5,
};
